import React from 'react';
import ReactOnRails from 'react-on-rails';

import {
  cdn,
  geoTiles,
  mathTiles,
  gameTypes,
  displayKey,
  shuffle,
  rollDice,
  bgImages,
  tilesByGameType,
  typeFromURL
} from './lib/tiles';

import GameBoard from './game-board';
import GameOptions from './game-options';
import GameHeader from './game-header';
import GameScore from './game-score';

const numTiles = 16; // Change this to show less tiles (for testing).

export default class Game extends React.Component {
  constructor(props) {
    super(props);
    const allTiles = tilesByGameType(typeFromURL());
    const gameTiles = shuffle(allTiles).slice(0, numTiles);
    const current = gameTiles[rollDice(numTiles)];
    this.state = {
      gameTiles: gameTiles,
      remaining: gameTiles,
      scoreCard: [],
      completed: false,
      uncovered: [],
      lastCurrent: null,
      current: current,
      seleted: null,
      lastSelected: null,
      gameType: typeFromURL(),
      gameDisplay: 'problem',
      bgImage: bgImages[rollDice(bgImages.length)]
    };
    this.chooseType.bind(this);
    this.chooseDisplay.bind(this);
    this.resetAction.bind(this);
  }

  success(tile) {
    const remaining = this.state.remaining.filter(t => {
      const t1 = Array.isArray(t) ? t[0] : t;
      const t2 = Array.isArray(tile) ? tile[0] : tile;
      return t1 !== t2;
    });

    let current = '';
    let completed = true;
    if (remaining.length > 0) {
      current = remaining[rollDice(remaining.length)];
      completed = false;
    }

    let uncovered = this.state.uncovered;
    uncovered.push(tile);
    let scoreCard = this.state.scoreCard;
    scoreCard.push(true);

    return {
      scoreCard: scoreCard,
      completed: completed,
      lastSelected: this.state.selected,
      uncovered: uncovered,
      selected: tile,
      remaining: remaining,
      current: current
    };
  }

  failed(tile) {
    let scoreCard = this.state.scoreCard;
    const remaining = this.state.remaining;
    scoreCard.push(false);
    return {
      scoreCard: scoreCard,
      selected: null,
      lastSelected: tile,
      current: remaining[rollDice(remaining.length)]
    };
  }

  chooseTile(tile) {
    let newState;
    if (this.state.gameType == 'geometry') {
      newState = tile === this.state.current ? this.success(tile) : this.failed(tile);
    } else {
      // Tiles other than geometry are an array.
      newState =
        this.state.current && tile[0] == this.state.current[0]
          ? this.success(tile)
          : this.failed(tile);
    }

    newState.selected = tile;
    newState.lastCurrent = this.state.current;
    this.setState(newState);
  }

  chooseType(type) {
    const allTiles = tilesByGameType(type);
    const gameTiles = shuffle(allTiles).slice(0, numTiles);
    const current = gameTiles[rollDice(numTiles)];
    this.setState({
      gameType: type,
      gameTiles: gameTiles,
      remaining: gameTiles,
      uncovered: [],
      completed: false,
      scoreCard: [],
      lastCurrent: null,
      current: current,
      seleted: null,
      lastSelected: null,
      bgImage: bgImages[rollDice(bgImages.length)]
    });
  }

  chooseDisplay(display) {
    this.setState({
      gameDisplay: display
    });
  }

  resetResult() {
    this.setState({
      selected: null
    });
  }

  resetAction() {
    this.chooseType(this.state.gameType);
  }

  geoTermsButton() {
    if (typeFromURL() == 'geometry') {
      return (
        <div className="cards--slim">
          <a className="card" href="/aplusmath/homework-helper/geoterms">
            <span className="card__data">
              <span className="card__title">Geoterms Helper</span>
            </span>
          </a>
        </div>
      );
    }
  }

  getTiles() {
    return this.state.gameTiles.map((tile, index) => {
      // Default (Uncovered)
      let style = { backgroundColor: 'transparent' };
      let label = '';

      const uncovered = this.state.uncovered.filter(t => {
        if (this.state.gameType == 'geometry') {
          return t == tile;
        } else {
          return t[0] == tile[0];
        }
      });

      if (uncovered.length == 0) {
        // Cover that space with a tile it
        if (this.state.gameType == 'geometry') {
          const filename = tile.replace(/\s/g, '-') + '.gif';
          style = { backgroundImage: `url(${cdn}/geoshapes/${filename})` };
        } else {
          style = { backgroundColor: 'white' };
          label = tile[displayKey[this.state.gameDisplay]];
        }
      }

      return (
        <div
          style={style}
          key={index}
          onClick={this.chooseTile.bind(this, tile)}
          onMouseOut={this.resetResult.bind(this)}
          className="game-board__tile">
          {label}
        </div>
      );
    });
  }

  render() {
    const bgImage = `${cdn}/pictures/${this.state.bgImage}.jpg`;
    const geoTermsButton = this.geoTermsButton();

    return (
      <div className="hidden-picture">
        <div className="row">
          <div className="col-sm-3 col-xs-12">
            <GameScore
              current={this.state.current}
              lastCurrent={this.state.lastCurrent}
              selected={this.state.selected}
              scoreCard={this.state.scoreCard}
              completed={this.state.completed}
            />
            <GameOptions
              chooseType={this.chooseType.bind(this)}
              chooseDisplay={this.chooseDisplay.bind(this)}
              gameDisplay={this.state.gameDisplay}
              resetAction={this.resetAction.bind(this)}
              gameType={this.state.gameType}
            />
            {geoTermsButton}
          </div>
          <div className="col-sm-9 col-xs-12">
            <GameHeader
              current={this.state.current}
              gameDisplay={this.state.gameDisplay}
              gameType={this.state.gameType}
            />
            <GameBoard
              getTiles={this.getTiles.bind(this)}
              chooseTile={this.chooseTile.bind(this)}
              gameDisplay={this.state.gameDisplay}
              gameType={this.state.gameType}
              completed={this.state.completed}
              bgImage={bgImage}
            />
          </div>
        </div>
      </div>
    );
  }
}

ReactOnRails.register({ Game });



/** WEBPACK FOOTER **
 ** ./client/app/scripts/components/hidden-picture/component.js
 **/